'use es6';

import keyMirror from 'react-utils/keyMirror';
export default keyMirror({
  GOOGLE: null,
  SSO: null,
  HUBSPOT: null,
  APPLE: null
});